import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon } from 'lucide-react';
interface Registration {
  id: number;
  name: string;
  timeAgo: string;
}
const names = ['María González', 'Carlos Rodríguez', 'Ana Martínez', 'Luis Hernández', 'Carmen López', 'José García', 'Laura Pérez', 'Miguel Sánchez', 'Isabel Ramírez', 'David Torres', 'Patricia Flores', 'Roberto Díaz', 'Elena Morales', 'Francisco Jiménez', 'Sofía Ruiz'];
const timeOptions = ['Hace 1 minuto', 'Hace 2 minutos', 'Hace 3 minutos', 'Hace 5 minutos', 'Justo ahora'];
export function NotificationToast() {
  const [notification, setNotification] = useState<Registration | null>(null);
  const [nextId, setNextId] = useState(0);
  useEffect(() => {
    const showNotification = () => {
      // Only show new notification if there isn't one currently visible
      if (notification === null) {
        const randomName = names[Math.floor(Math.random() * names.length)];
        const randomTime = timeOptions[Math.floor(Math.random() * timeOptions.length)];
        const newNotification: Registration = {
          id: nextId,
          name: randomName,
          timeAgo: randomTime
        };
        setNotification(newNotification);
        setNextId(prev => prev + 1);
        // Remove notification after 5 seconds
        setTimeout(() => {
          setNotification(null);
        }, 5000);
      }
    };
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(showNotification, 3000);
    // Then try to show notifications every 8-12 seconds
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 4000 + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [notification, nextId]);
  return <div className="fixed bottom-6 left-0 right-0 z-50 pointer-events-none px-4" data-id="element-331">
      <div className="max-w-md mx-auto" data-id="element-332">
        <AnimatePresence data-id="element-333">
          {notification && <motion.div key={notification.id} initial={{
          y: 100,
          opacity: 0,
          scale: 0.8
        }} animate={{
          y: 0,
          opacity: 1,
          scale: 1
        }} exit={{
          y: 100,
          opacity: 0,
          scale: 0.8
        }} transition={{
          type: 'spring',
          stiffness: 500,
          damping: 30
        }} className="bg-gray-800 bg-opacity-30 backdrop-blur-md border border-gray-600 border-opacity-40 rounded-2xl shadow-xl p-3 pointer-events-auto" style={{
          background: 'linear-gradient(135deg, rgba(31, 41, 55, 0.25) 0%, rgba(17, 24, 39, 0.3) 100%)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.2), inset 0 1px 1px 0 rgba(255, 255, 255, 0.1), 0 0 20px 0 rgba(59, 130, 246, 0.15)'
        }} data-id="element-334">
              <div className="flex items-center space-x-3" data-id="element-335">
                <div className="flex-shrink-0" data-id="element-336">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center shadow-lg" data-id="element-337">
                    <UserIcon className="h-5 w-5 text-white" data-id="element-338" />
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-339">
                  <div className="flex items-center justify-between mb-0.5" data-id="element-340">
                    <p className="text-sm font-bold text-white text-opacity-90" data-id="element-341">
                      Masterclass Gratuita
                    </p>
                    <span className="text-xs text-gray-300 text-opacity-80 ml-2 flex-shrink-0" data-id="element-342">
                      {notification.timeAgo}
                    </span>
                  </div>
                  <p className="text-xs text-gray-100 text-opacity-85" data-id="element-343">
                    <span className="font-semibold" data-id="element-344">{notification.name}</span>{' '}
                    acaba de reservar su lugar
                  </p>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}